import ElementUI from 'element-ui'
import Vue from 'vue'

function returnSuccess(val, returnType, moreValue) {
    let msg = ""
    if (moreValue) {
        moreValue = ',' + moreValue
        msg = returnType + '成功 ' + moreValue

    }
    msg = returnType + '成功 '
    if (val == "success") {
        ElementUI.Message({
            message: msg,
            type: "success",
        });
    }
}
function returnRrror(val,returnType){
    if (val == "error") {
        ElementUI.Message({
            message: returnType,
            type: "error",
        });
    }
}
export default {
    returnSuccess,
    returnRrror
}